import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import Button from '../common/Button';
import './VendorDetail.css';

const VendorDetail = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [vendor, setVendor] = useState(null);
  const [loading, setLoading] = useState(true);
  const [notes, setNotes] = useState('');

  useEffect(() => {
    setTimeout(() => {
      setVendor({
        id: id,
        companyName: 'MarineTech Solutions FZC',
        email: 'info@marinetech.ae',
        phone: '+971 4 123 4567',
        website: 'www.marinetech.ae',
        address: 'Dubai Maritime City, Dubai, UAE',
        registrationNo: 'MT-2022-0891',
        taxId: 'TX-456789-01',
        established: '2022',
        employees: '15-20',
        description: 'Leading provider of GMDSS, navigation, and safety equipment services.',
        verificationStatus: 'pending',
        rating: 4.8,
        totalJobs: 156,
        completedJobs: 148,
        responseRate: 98,
        certificates: ['ISO 9001:2015', 'DNV Approved', 'LR Certified'],
        specializations: ['GMDSS', 'Navigation', 'Safety Equipment'],
        ports: ['Dubai', 'Singapore', 'Fujairah'],
        documents: [
          { id: 1, name: 'Trade License.pdf', uploaded: '2024-03-10', status: 'approved' },
          { id: 2, name: 'Insurance Certificate.pdf', uploaded: '2024-03-10', status: 'pending' },
          { id: 3, name: 'ISO Certificate.pdf', uploaded: '2024-03-10', status: 'approved' }
        ],
        approvalHistory: [
          { id: 1, action: 'Application Submitted', by: 'MarineTech Solutions', date: '2024-03-10' },
          { id: 2, action: 'Documents Under Review', by: 'System', date: '2024-03-11' },
          { id: 3, action: 'Additional Documents Requested', by: 'Admin Sarah', date: '2024-03-12' }
        ]
      });
      setLoading(false);
    }, 500);
  }, [id]);

  const handleVerify = () => {
    alert('Vendor verified successfully');
  };

  const handleReject = () => {
    if (window.confirm('Are you sure you want to reject this vendor application?')) {
      alert('Vendor application rejected');
    }
  };

  const handleSaveNotes = () => {
    alert('Notes saved');
  };

  if (loading) return <div className="loading-spinner">Loading vendor details...</div>;

  return (
    <div className="admin-vendor-detail">
      <button className="back-btn" onClick={() => navigate('/admin/verify-service-providers')}>
        <i className="fas fa-arrow-left"></i> Back to Vendors
      </button>

      <div className="vendor-header-card">
        <div className="vendor-header">
          <div className="vendor-avatar">
            {vendor.companyName.charAt(0)}
          </div>
          <div className="vendor-info">
            <h1>
              {vendor.companyName}
              <span className={`verification-badge ${vendor.verificationStatus}`}>
                {vendor.verificationStatus === 'verified' ? 'Verified' : 
                 vendor.verificationStatus === 'pending' ? 'Pending Verification' : 'Rejected'}
              </span>
            </h1>
            <div className="vendor-stats">
              <div className="stat">
                <span className="stat-label">Total Jobs</span>
                <span className="stat-value">{vendor.totalJobs}</span>
              </div>
              <div className="stat">
                <span className="stat-label">Completed</span>
                <span className="stat-value">{vendor.completedJobs}</span>
              </div>
              <div className="stat">
                <span className="stat-label">Rating</span>
                <span className="stat-value">{vendor.rating} ★</span>
              </div>
              <div className="stat">
                <span className="stat-label">Response Rate</span>
                <span className="stat-value">{vendor.responseRate}%</span>
              </div>
            </div>
            <div className="action-buttons">
              {vendor.verificationStatus === 'pending' && (
                <>
                  <Button variant="primary" onClick={handleVerify} icon="fa-check">
                    Verify Vendor
                  </Button>
                  <Button variant="danger" onClick={handleReject} icon="fa-times">
                    Reject
                  </Button>
                </>
              )}
              <Button variant="secondary" icon="fa-envelope">
                Contact Vendor
              </Button>
            </div>
          </div>
        </div>
      </div>

      <div className="profile-section">
        <h3><i className="fas fa-building"></i> Company Information</h3>
        <div className="info-grid">
          <div className="info-item">
            <span className="info-label">Registration Number</span>
            <span className="info-value">{vendor.registrationNo}</span>
          </div>
          <div className="info-item">
            <span className="info-label">Tax ID / VAT</span>
            <span className="info-value">{vendor.taxId}</span>
          </div>
          <div className="info-item">
            <span className="info-label">Email</span>
            <span className="info-value">{vendor.email}</span>
          </div>
          <div className="info-item">
            <span className="info-label">Phone</span>
            <span className="info-value">{vendor.phone}</span>
          </div>
          <div className="info-item">
            <span className="info-label">Website</span>
            <span className="info-value">{vendor.website}</span>
          </div>
          <div className="info-item">
            <span className="info-label">Address</span>
            <span className="info-value">{vendor.address}</span>
          </div>
          <div className="info-item">
            <span className="info-label">Year Established</span>
            <span className="info-value">{vendor.established}</span>
          </div>
          <div className="info-item">
            <span className="info-label">Employees</span>
            <span className="info-value">{vendor.employees}</span>
          </div>
        </div>
      </div>

      <div className="profile-section">
        <h3><i className="fas fa-certificate"></i> Certifications</h3>
        <div className="tags">
          {vendor.certificates.map((cert, idx) => (
            <span key={idx} className="tag"><i className="fas fa-check-circle"></i> {cert}</span>
          ))}
        </div>
      </div>

      <div className="profile-section">
        <h3><i className="fas fa-cog"></i> Specializations</h3>
        <div className="tags">
          {vendor.specializations.map((spec, idx) => (
            <span key={idx} className="tag">{spec}</span>
          ))}
        </div>
      </div>

      <div className="profile-section">
        <h3><i className="fas fa-file-alt"></i> Documents</h3>
        <div className="documents-list">
          {vendor.documents.map(doc => (
            <div key={doc.id} className="doc-item">
              <div className="doc-name">
                <i className="fas fa-file-pdf"></i>
                {doc.name}
              </div>
              <div>
                <span className={`doc-status ${doc.status}`}>
                  {doc.status}
                </span>
                <Button variant="secondary" size="small" icon="fa-download" style={{ marginLeft: '8px' }}>
                  View
                </Button>
              </div>
            </div>
          ))}
        </div>
      </div>

      <div className="profile-section">
        <h3><i className="fas fa-history"></i> Approval History</h3>
        <div className="approval-history">
          {vendor.approvalHistory.map(history => (
            <div key={history.id} className="history-item">
              <div>
                <div className="history-action">{history.action}</div>
                <div className="history-date">by {history.by}</div>
              </div>
              <div className="history-date">{history.date}</div>
            </div>
          ))}
        </div>
      </div>

      <div className="profile-section notes-section">
        <h3><i className="fas fa-sticky-note"></i> Admin Notes</h3>
        <textarea rows="4" placeholder="Add internal notes about this vendor..." value={notes} onChange={(e) => setNotes(e.target.value)} />
        <Button variant="secondary" onClick={handleSaveNotes} style={{ marginTop: '12px' }}>
          Save Notes
        </Button>
      </div>
    </div>
  );
};

export default VendorDetail;